import styled from '@emotion/styled';
import React from 'react';
import SEO from '../components/seo';
import Layout from '../components/layout';
import { StyledSection } from '../components/_shared/styled-section';
import { StyledH2 } from '../components/_shared/styled-headings';
import { StyledP } from '../components/_shared/styled-headings';
// import { StyledTag } from '../components/_shared/styled-headings';
import { flexCenter } from '../components/_shared/styled-mixins';
import Logo from '../assets/partyicon.svg';
import ButtonLink from '../components/links/button-link';

const StyledTextSection = styled(StyledSection)`
  min-height: calc(100vh - var(--header-height));
  ${flexCenter};
`;

const StyledIcon = styled(Logo)`
  width: 100px;
  padding-bottom: 0.5rem;
  height: auto;
`;

const BtnContainer = styled.div`
  max-width: 200px !important;
  margin: 0 auto;
  padding-top: 1.5rem;
`;

const MissionPage = () => (
  <Layout>
    <StyledTextSection>
      <SEO title="Our Mission" />
      <StyledIcon />
      <StyledH2>We are on the road to 10K</StyledH2>
      <StyledP>
        Our mission is to help 10,000 candidates get matched and hired in roles. We are currently in
        <strong style={{ color: 'var(--secondary-color)' }}> beta</strong> and will be making improvements in our
        service on a regular basis.
      </StyledP>
      <BtnContainer>
        <ButtonLink label="Get Started" link="/join" />
      </BtnContainer>
    </StyledTextSection>
  </Layout>
);

export default MissionPage;
